import * as types from '../constants/ActionTypes';

export const setPatient = (patient) => ({
  type: types.SET_PATIENT,
  patient,
});

export const addStudy = (study) => ({
  type: types.ADD_STUDY,
  study,
});

export const setMainStudyId = (StudyInstanceUID) => ({
  type: types.SET_MAIN_STUDY_ID,
  StudyInstanceUID,
});

export const setFetchedStudies = (studies) => ({
  type: types.SET_FETCHED_STUDIES,
  studies,
});
